<template>
  <section class="flex-1 relative w-0 z-10">
    <div class="w-full main p-16">
      <!--      铁人三项tab-->
      <div
        v-if="sportDataDetailList.length"
        class="tabs mb-12"
      >
        <ButtonGroup>
          <Button
            class="tab-item"
            v-for="(item, index) in tabs"
            @click="changeTab(item.key)"
            :key="'tab-item-' + index"
            :type="activeTab === item.key ? 'primary' : 'secondary'"
            >{{ item.text }}</Button
          >
        </ButtonGroup>
      </div>
      <!-- 数据图表-->
      <ChartCard
        class="select-none"
        v-if="activityDetail?.frequencyList?.length"
      ></ChartCard>

      <!--数据表格-->
      <!-- 圈速表-->
      <template v-if="showLapListCard && (activityDetail?.lapList?.length || sportDataDetailList?.length)">
        <BottomTable class="w-full"></BottomTable>
      </template>
    </div>
  </section>
</template>

<script setup>
import { computed } from 'vue';
import { ButtonGroup, Button } from '@arco-design/web-vue';
import { activityDetailStore } from '@client/store/activityDetailStore';
import { getTabsData } from './tabs';
import definition from '@client/config/definition';
import BottomTable from './table/BottomTable.vue';
import ChartCard from './chart/ChartCard.vue';
import { changeActiveTab, activeTab } from '@client/pages/activity-detail/hooks/useActivityTabs';

const activityDetailStoreRef = activityDetailStore();

function changeTab(val) {
  changeActiveTab(val);
  activityDetailStoreRef.changeActiveTab();
}

const activityDetail = computed(() => activityDetailStoreRef.activityDetail);
const sportDataDetailList = computed(() => activityDetailStoreRef.sportDataDetailList);
const topSportType = computed(() => activityDetailStoreRef.topSummary.sportType);

const tabs = computed(() => {
  return getTabsData(topSportType.value, sportDataDetailList.value);
});

// 是否显示圈速表卡片
const showLapListCard = computed(() => {
  // 这里是子 sportType 706 竞速帆板
  return !['Speedsurfing'].includes(definition.getSportNameByType(activityDetailStoreRef.sportType));
});
</script>

<style lang="scss" scoped>
@import '@client/styles/_mixins.scss';
.main {
  position: relative;
  height: 100%;
  box-sizing: border-box;
  overflow: auto;

  &::-webkit-scrollbar {
    display: none;
  }
}
</style>
